import { render, staticRenderFns } from "./AppointmentDetailsPanel.vue?vue&type=template&id=033e5fa7"
import script from "./AppointmentDetailsPanel.vue?vue&type=script&lang=ts"
export * from "./AppointmentDetailsPanel.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentDetailsPanel.vue?vue&type=style&index=0&id=033e5fa7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports